import TownBuyerLandingPage from "./TownBuyerLandingPage";
const MoorestownLanding = () => (
  <TownBuyerLandingPage townName="Moorestown" slug="homes-for-sale-moorestown" savedLinkId="10350" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-moorestown-ac" />
);
export default MoorestownLanding;
